module.exports = __webpack_public_path__ + "static/media/ws.d9592f3f.svg";